import { render, staticRenderFns } from "./Widget33.vue?vue&type=template&id=74d8d788"
var script = {}
import style0 from "./Widget33.vue?vue&type=style&index=0&id=74d8d788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports